// ---------------------------------------------------------------------------
// The 2.1 feature switches of the admin dashboard (NDI-230)
//
// Pure, so the set a switch sends can be tested without a page: the server
// replaces a user's flags with exactly what it is sent (all or nothing), so a
// switch always sends the whole new set.
// ---------------------------------------------------------------------------

/** The German name an operator sees; the server's catalogue gives the description. */
const LABELS: Record<string, string> = {
  leadSourcing: 'Lead Sourcing',
  crossSourceSearch: 'Suche über Quellen',
  assessmentAgent: 'Assessment Agent',
};

export function featureLabel(flag: string): string {
  return LABELS[flag] ?? flag;
}

/** The user's flags after one switch, each once, sorted — what PUT /admin/api/users/:id/features takes. */
export function toggledFlags(current: readonly string[] | undefined, flag: string, on: boolean): string[] {
  const set = new Set(current ?? []);
  if (on) set.add(flag);
  else set.delete(flag);
  return [...set].sort();
}
